// The stack of cards over a screen (R-U19, DESIGN.md «Модалки и стопка»): a record linked from a single opens as a modal on the right,
// the next one lies on top. The stack lives in the address (`?card=a,b,c`, the top last), so a link opens it, «назад» of the browser
// closes the top card and leaving for another section (another path) leaves the stack behind.

import { cameFromApp, navigate } from './router.ts';
import { leaveThen } from './unsaved.ts';

export const CARD_PARAM = 'card';
const ID = /^[0-9a-f-]{36}$/;
/** Deeper cards stay in the address but are not drawn: the stack shows its last few (ui/ModalStack). */
const MAX = 8;

/** The cards of an address, bottom first; a malformed id is dropped, not opened. */
export function cardsOf(search: URLSearchParams): string[] {
  return (search.get(CARD_PARAM) ?? '').split(',').filter((x) => ID.test(x)).slice(-MAX);
}

/** The address with this stack of cards; an empty stack drops the parameter. */
export function withCards(href: string, cards: string[]): string {
  const u = new URL(href, 'http://x');
  if (cards.length) u.searchParams.set(CARD_PARAM, cards.join(','));
  else u.searchParams.delete(CARD_PARAM);
  const q = u.searchParams.toString().replace(/%2C/g, ',');
  return u.pathname + (q ? `?${q}` : '') + u.hash;
}

const now = () => cardsOf(new URLSearchParams(location.search));
const href = () => location.pathname + location.search;

/** Lays a card on top of the stack; a card already in the stack comes back to the top by closing the ones above it. */
export function openCard(id: string): void {
  const cur = now();
  if (cur[cur.length - 1] === id) return;
  const at = cur.indexOf(id);
  if (at >= 0) { closeCardsFrom(at + 1); return; }
  navigate(withCards(href(), [...cur, id]), { card: true });
}

/** Closes the cards from `index` up. The top card laid in this tab goes by the browser's «назад», so «вперёд» brings it again. */
export function closeCardsFrom(index: number): void {
  const cur = now();
  if (index >= cur.length) return;
  const state = history.state as { card?: boolean } | null;
  if (index === cur.length - 1 && state?.card && cameFromApp()) { history.back(); return; }
  // A replacement is not asked about by the router: closing a card with unsaved work in it asks here (shell/unsaved.ts).
  leaveThen(() => navigate(withCards(href(), cur.slice(0, index)), { replace: true }));
}

export const closeTopCard = () => closeCardsFrom(now().length - 1);
